module.exports = __webpack_public_path__ + "img/guide_happy.96633482.png";